import styled from 'styled-components';
import DialogContentText from '@material-ui/core/DialogContentText';

export const DialogContentTextWrapper = styled(DialogContentText)`
  color: #12253f;
`;
